// Lightweight loader for Razorpay's Checkout JS. Resolves once the
// global `window.Razorpay` constructor is available. Resolves to false
// if the script fails to load (offline / blocked).
let _loaded = null;

export function loadRazorpay() {
  if (_loaded) return _loaded;
  _loaded = new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(!!window.Razorpay);
    s.onerror = () => {
      _loaded = null;
      resolve(false);
    };
    document.body.appendChild(s);
  });
  return _loaded;
}
